import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as usersActions from '../../redux/actions/usersActions';
import { bodyScroll } from '../../utils/utils';

import RegisterConfirmationModal from '../features/account/RegisterConfirmationModal';
import InputErrors from '../common/InputErrors';
import LoadingButton from '../common/LoadingButton';

class RegisterPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      institution: '',
      position: '',
      department: '',
      location: '',
      showModal: false,
      serverErrors: [],
      isLoading: false,
      modalErrors: [],
      invalidEmailError: false,
      noFirstNameError: false,
      noLastNameError: false,
    };
    this.emailRef = React.createRef();
  }

  toggleModal = () => {
    bodyScroll.toggle();
    this.setState(prevState => ({
      showModal: !prevState.showModal,
      emailResent: false, // reset UI just in case
    }));
  }

  register = (e) => {
    const { email, firstName, lastName, institution, position, department, location } = this.state;
    const { dispatchUsersActions } = this.props;

    e.preventDefault();
    this.resetErrors();
    if (!this.emailRef.current.checkValidity() || !email) {
      this.setState({ invalidEmailError: true });
    } else if (!firstName) {
      this.setState({ noFirstNameError: true });
    } else if (!lastName) {
      this.setState({ noLastNameError: true });
    } else {
      // We're good to try submitting
      dispatchUsersActions.register({
        firstName,
        lastName,
        email,
        institution,
        position,
        department,
        location,
      }, this.onSuccess, this.onFail);
      this.setState({ isLoading: true });
    }
  }

  resetErrors = () => {
    this.setState({
      serverErrors: [],
      modalErrors: [],
      invalidEmailError: false,
      noFirstNameError: false,
      noLastNameError: false,
    });
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  onSuccess = () => {
    this.toggleModal();
    this.setState({ isLoading: false });
  }

  onFail = (error) => {
    this.setState({
      serverErrors: error.response
        ? error.response.data
        : ['There was a problem reaching the server.'],
      isLoading: false,
    });
  }

  resend = () => {
    const { dispatchUsersActions } = this.props;

    dispatchUsersActions.register(this.state, this.onResendSuccess, this.onResendFail);
    this.setState({ isLoading: true });
  }

  onResendSuccess = () => {
    this.setState({ emailResent: true, isLoading: false });
  }

  onResendFail = (error) => {
    this.setState({
      // modalErrors: ['There was a problem reaching the server.'],
      modalErrors: error.response
        ? error.response.data
        : ['There was a problem reaching the server.'],
      isLoading: false,
    });
  }

  render() {
    const { loggedIn } = this.props;
    const { serverErrors, modalErrors, showModal, firstName, lastName, email, institution, location, department, position, isLoading, emailResent, invalidEmailError, noFirstNameError, noLastNameError } = this.state;

    // Aggregate error messages
    let errors = serverErrors;
    if (invalidEmailError) errors = [...errors, 'Please enter a valid email address.'];
    if (noFirstNameError) errors = [...errors, 'Your first name is required.'];
    if (noLastNameError) errors = [...errors, 'Your last name is required.'];

    return loggedIn ? (
      // Don't allow users to register if they're already logged in
      <Redirect to="/" />
    ) : (
      <Fragment>
        <Helmet>
          <title>Create an Account</title>
        </Helmet>
        <div className="fullscreen-form fullscreen-form--muted">
          <div className="row fullscreen-form__content">
            <h1 className="fullscreen-form__heading fullscreen-form__heading--extra-margin">
              Create an Account
            </h1>
            <form className="form fullscreen-form__form fullscreen-form__form--extra-margin">
              {errors.length !== 0 && <InputErrors errors={errors} />}
              <label htmlFor="firstName">
                First Name
              </label>
              <input
                name="firstName"
                id="firstName"
                value={firstName}
                onChange={this.handleInputChange}
                type="text"
              />
              <label htmlFor="lastName">
                Last Name
              </label>
              <input
                name="lastName"
                id="lastName"
                value={lastName}
                onChange={this.handleInputChange}
                type="text"
              />
              <label htmlFor="email">
                Email
              </label>
              <input
                name="email"
                id="email"
                value={email}
                onChange={this.handleInputChange}
                type="email"
                ref={this.emailRef}
              />
              <label htmlFor="institution">
                Institution
              </label>
              <input
                name="institution"
                id="institution"
                value={institution}
                onChange={this.handleInputChange}
                type="text"
              />
              <label htmlFor="location">
                Unit Location
              </label>
              <input
                name="location"
                id="location"
                value={location}
                onChange={this.handleInputChange}
                type="text"
              />
              <label htmlFor="department">
                Department
              </label>
              <input
                name="department"
                id="department"
                value={department}
                onChange={this.handleInputChange}
                type="text"
              />
              <label htmlFor="position">
                Position Title
              </label>
              <input
                name="position"
                id="position"
                value={position}
                onChange={this.handleInputChange}
                type="text"
              />
              <div className="fullscreen-form__button-wrapper">
                <LoadingButton
                  text="Register"
                  onClick={this.register}
                  loading={isLoading}
                />
                <br />
                <Link to="/login" className="flat-link">
                  Already have an account? Log in here
                </Link>
              </div>
            </form>
          </div>
        </div>
        <RegisterConfirmationModal
          visible={showModal}
          toggleModal={this.toggleModal}
          resend={this.resend}
          emailResent={emailResent}
          errors={modalErrors}
        />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { loggedIn: state.users.currentUserId && sessionStorage.jwt };
}

function mapDispatchToProps(dispatch) {
  return { dispatchUsersActions: bindActionCreators(usersActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RegisterPage);



// WEBPACK FOOTER //
// ./src/components/pages/RegisterPage.js